import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import _ from 'lodash';
import dayjs from 'dayjs';
import { AssetType } from '@tradingblock/types';
import { PositionsUrl } from '../constants';
import { deriveRootSymbol, deriveOptionExpirationType } from '../utilities/SymbolUtilities';
export var get = function get(api) {
  return function (accountId, subaccountId) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var res, payload, responseCode, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.get(PositionsUrl, {
                accountId: accountId,
                subaccountId: subaccountId
              });

            case 2:
              res = _context.sent;
              payload = res.payload, responseCode = res.responseCode;
              data = _.map(payload, function (position) {
                var isOption = position.AssetType === AssetType.Option;
                var PositionId = "".concat(position.Symbol, "-").concat(dayjs(position.DateOpened).valueOf(), "-").concat(position.OrderId);
                var isMutualFund = position.AssetType === AssetType.MutualFund || position.AssetType === AssetType.MoneyMarket;
                var res = Object.assign({}, position, {
                  PositionId: PositionId,
                  Symbol: isMutualFund ? ':' + position.Symbol : position.Symbol,
                  UnderlyingSymbol: isMutualFund ? ':' + position.UnderlyingSymbol : position.UnderlyingSymbol,
                  meta: {
                    OptionExpirationType: isOption ? deriveOptionExpirationType(position.Symbol, position.UnderlyingSymbol) : undefined,
                    RootSymbol: deriveRootSymbol(position.Symbol),
                    Description: position.Description
                  }
                });
                return res;
              });
              return _context.abrupt("return", Object.assign({}, res, {
                payload: data,
                responseCode: responseCode
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};